import React, { useEffect } from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./footer.module.scss"
import Button from "../../atoms/button"
import Logo from "../../atoms/logo"
import Wrapper from "../../atoms/wrapper"
import Nav from "../../molecules/nav"
import Social from "../../molecules/social"

const Footer = ({ currentVertical }) => {
  const { site, allSanityDictionary, allSanityCountry, bottomNav, footerNav } =
    useStaticQuery(graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
        allSanityCountry {
          nodes {
            abbreviation
            url
            emoji
            name
          }
        }
        bottomNav: sanityNavigation(type: { eq: "bottom" }) {
          items {
            title
            type
            url
            submenu {
              items {
                url
                title
                type
                email_subject
                email_body
                email_address
              }
            }
            email_body
            email_address
            email_subject
          }
        }
        footerNav: sanityNavigation(type: { eq: "footer" }) {
          items {
            title
            type
            url
            submenu {
              items {
                url
                title
                type
                email_subject
                email_body
                email_address
              }
            }
            email_body
            email_address
            email_subject
          }
        }
      }
    `)

  useEffect(() => {
    document.documentElement.setAttribute(
      "region",
      allSanityCountry.nodes.find((c) => c.url === site.siteMetadata.siteUrl)
        .abbreviation
    )
  }, [])

  return (
    <footer className={styles.footer}>
      <Wrapper flex="desktop">
        <Logo light full />
        <Nav nav={footerNav.items} type="footer" />
        <div className={styles.buttons}>
          <ul className={styles.region}>
            {allSanityCountry.nodes.map((c) => (
              <li>
                <a
                  className={`${
                    site.siteMetadata.siteUrl === c.url
                      ? styles.region__active
                      : ""
                  } ${styles.regionItem}`}
                  href={c.url}
                >
                  <span role="img" aria-label={c.name}>
                    {c.emoji}
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <Button
            fullWidth
            variant="tertiary"
            className={styles.subscribe}
            url={`/subscribe${currentVertical ? `-${currentVertical}` : ""}`}
          >
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "subscribe_gated"
              )?.value
            }
          </Button>
          <Social light spaced />
        </div>
      </Wrapper>
      <Wrapper className={styles.bottom}>
        © {new Date().getFullYear()}{" "}
        {
          allSanityDictionary.nodes.find(
            (item) => item.key.current === "copyright_text"
          )?.value
        }{" "}
        <Nav nav={bottomNav.items} type="bottom" />
      </Wrapper>
    </footer>
  )
}

export default Footer

Footer.propTypes = {
  currentVertical: PropTypes.string,
}

Footer.defaultProps = {
  currentVertical: "",
}
